import { render, staticRenderFns } from "./ExaminationSetting.vue?vue&type=template&id=6ced7358&scoped=true"
import script from "./ExaminationSetting.vue?vue&type=script&lang=js"
export * from "./ExaminationSetting.vue?vue&type=script&lang=js"
import style0 from "./ExaminationSetting.vue?vue&type=style&index=0&id=6ced7358&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ced7358",
  null
  
)

export default component.exports